"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDisplayImageUrl() {
    return (state, actions, { tabName = state.ui.currentTabName } = {}) => () => {
        const tabState = state.tabs[tabName];
        if (!actions.getters.getIsMobileTab()) {
            return tabState.imageUrl;
        }
        switch (tabState.imageVisibilityState) {
            case 'showImage':
                return tabState.imageUrl;
            case 'hideImage':
                return '';
            default:
                return state.tabs.default.imageUrl;
        }
    };
}
exports.getDisplayImageUrl = getDisplayImageUrl;
//# sourceMappingURL=get-display-image-url.js.map